var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 515,
    viewBox: "0 0 1920 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_965_1434)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_965_1434)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_965_1434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2554V119.682L0 420V0Z",
    fill: "#F0F2F8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 352.352L466.667 294V365.111L0 423.463V352.352Z",
    fill: "#CFD5EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-210 449.143L255 391V461.857L-210 520V449.143Z",
    fill: "#98A5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284 245.343L1964 160V231.111L1284 316.454V245.343Z",
    fill: "#B8C1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497 148.352L1963.67 90V161.111L1497 219.463V148.352Z",
    fill: "#98A5D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1738 259.352L2204.67 201V272.111L1738 330.463V259.352Z",
    fill: "#CFD5EB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_965_1434",
    x: -111.111,
    y: -111.111,
    width: 2776.22,
    height: 642.222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 55.5556
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_965_1434"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_965_1434",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_965_1434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 515,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_965_1434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 515,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.6da65ad4b4445afd5953ac82885b00d1.svg";
export { ForwardRef as ReactComponent };